import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../pages/Blogs/Blogs.css";
import { buildPastedTableHtml } from "./pasteTable";

const Quill = ReactQuill.Quill;
const Delta = Quill.import("delta");
const BlockEmbed = Quill.import("blots/block/embed");

const Font = Quill.import("formats/font");
Font.whitelist = ["mirza", "roboto"];
Quill.register(Font, true);

class BlogTableBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute("contenteditable", "false");
    node.innerHTML = typeof value === "string" ? value : "";
    return node;
  }

  static value(node) {
    return node.innerHTML;
  }
}

BlogTableBlot.blotName = "blog-table";
BlogTableBlot.tagName = "DIV";
BlogTableBlot.className = "blog-table";
Quill.register(BlogTableBlot, true);

function clipboardTableMatcher(node, delta) {
  if (node.closest("td, th")) return delta;
  const html = buildPastedTableHtml(node);
  if (!html) return delta;
  return new Delta().insert({ "blog-table": html });
}

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ script: "sub" }, { script: "super" }],
    ["code-block"],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    matchers: [["table", clipboardTableMatcher]],
  },
};

const TextEditor = ({ onChange, value }) => {
  return (
    <>
      <ReactQuill theme="snow" value={value} modules={modules} onChange={onChange} />
      <p className="blog-editor-hint">
        Copy a table from Word, Google Docs, or Excel and paste it here. Rows, columns, and the header color are kept.
      </p>
    </>
  );
};

export default TextEditor;
